interface SubscriptionReq {
	topicName: string;
	es: boolean;
}

export const cellebriteSheetTopics: SubscriptionReq[] = [
	{
		topicName: 'status.upload',
		es: false,
	},
	{
		topicName: 'processed.cellebrite.cellebrite-data',
		es: true,
	},
	{
		topicName: 'processed.cellebrite.cellebrite-meta',
		es: true,
	},
	{
		topicName: 'processed.cellebrite.cellebrite-times',
		es: true,
	},
	{
		topicName: 'processed.cellebrite.postcode',
		es: true,
	},
	{
		topicName: 'processed.cellebrite.ip_address',
		es: true,
	},
];

export const cellebriteXmlTopics: SubscriptionReq[] = [
	{
		topicName: 'status.upload',
		es: false,
	},
	{
		topicName: 'tracking.cellebrite',
		es: false,
	},
	{
		topicName: 'processed.cellebrite.xml_cellebrite_conversations',
		es: true,
	},
	{
		topicName: 'enrich.cellebrite.xml_cellebrite_conversations',
		es: true,
	},
	{
		topicName: 'processed.cellebrite.xml_cellebrite_risk',
		es: true,
	},
];

export const stellarCellebriteXMLTopics: SubscriptionReq[] = [
	{
		topicName: 'status.upload',
		es: false,
	},
	{
		topicName: 'processed.stellar.solartorch-v1-actor',
		es: true,
	},
	{
		topicName: 'processed.stellar.solartorch-v1-email',
		es: true,
	},
	{
		topicName: 'processed.stellar.solartorch-v1-file_entry',
		es: true,
	},
	{
		topicName: 'processed.stellar.solartorch-v1-group',
		es: true,
	},
	{
		topicName: 'processed.stellar.solartorch-v1-location',
		es: true,
	},
	{
		topicName: 'processed.stellar.solartorch-v1-message',
		es: true,
	},
	{
		topicName: 'processed.stellar.solar-torch-log',
		es: true,
	},
];

export const axiomTopics: SubscriptionReq[] = [
	{
		topicName: 'status.upload',
		es: false,
	},
	{
		topicName: 'tracking.axiom',
		es: false,
	},
	{
		topicName: 'processed.cellebrite.xml_cellebrite_conversations',
		es: true,
	},
	{
		topicName: 'enrich.cellebrite.xml_cellebrite_conversations',
		es: true,
	},
];

export const anprTopics: SubscriptionReq[] = [
	{
		topicName: 'status.upload',
		es: false,
	},
	{
		topicName: 'processed.anpr.anpr',
		es: true,
	},
];

export enum SubscriptionOptions {
	CELLEBRITE_SHEET,
	CELLEBRITE_XML,
	STELLAR_CELLEBRITE_XML,
	ANPR,
	AXIOM,
}
